import { render, staticRenderFns } from "./CertificacionDescargoPage.vue?vue&type=template&id=424cd324"
import script from "./CertificacionDescargoPage.js?vue&type=script&lang=js&external"
export * from "./CertificacionDescargoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports